import { FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAppDispatch } from 'hooks/store'
import { setTitle } from 'reducers/activecourse/activecourseSlice'

import { ComeBackLaterBtn, ComeBackLaterText } from './styles'

interface CourseTabFirstCaseFiledProps {
  title: string
}

const CourseTabFirstCaseFiled: FC<CourseTabFirstCaseFiledProps> = ({
  title
}) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setTitle(title))
  }, [])

  const handleClickSecondCourse = () => {
    const tab = document.querySelector<HTMLAnchorElement>(
      'a[id$="-second-course"]'
    )

    tab?.click()
  }

  return (
    <ComeBackLaterText data-testid='course-tab-first-filed'>
      Your case has been filed. Please{' '}
      <Link to='/dashboard/lawfirminformation'>contact your attorney</Link> for
      more information. Or proceed to take the{' '}
      <ComeBackLaterBtn
        variant='link'
        onClick={handleClickSecondCourse}
        data-testid='course-tab-first-filed-button'
      >
        second course
      </ComeBackLaterBtn>
      .
    </ComeBackLaterText>
  )
}

export default CourseTabFirstCaseFiled
